import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
import { getInitialLocale } from './helpers/getInitialLocale';
import { localeStorage } from './localeStorage';
const LocaleContext = createContext(undefined);
export const LocaleProvider = ({ children, initialLocale, }) => {
    const usedInitialLocale = getInitialLocale(initialLocale);
    const [locale, setLocaleState] = useState(usedInitialLocale);
    const setLocale = (newLocale) => {
        localeStorage.set({ selectedLocale: newLocale });
        setLocaleState(newLocale);
    };
    return (_jsx(LocaleContext.Provider, { value: { locale, setLocale }, children: children }));
};
export const useLocale = () => {
    const context = useContext(LocaleContext);
    if (context === undefined) {
        throw new Error('useLocale must be used within a LocaleProvider');
    }
    return context;
};
